<template>
  <v-navigation-drawer
    id="appDrawer"
    :mini-variant.sync="mini"
    fixed
    :dark="$vuetify.dark"
    app
    v-model="drawer"
    width="225"
  >
    <v-toolbar color="primary" dark>
      <img v-bind:src="computeLogo" height="36" alt="Aplikacja utrzymaniowa" />
    </v-toolbar>
    <vue-perfect-scrollbar
      class="drawer-menu--scroll"
      :settings="scrollSettings"
    >
      <v-list dense expand>
        <template v-for="(item, i) in menuItems">
          <!--group with subitems-->
          <v-list-group
            v-if="item.items && validPermission(item)"
            :key="item.name"
            :group="item.group"
            :prepend-icon="item.route.meta.icon"
            no-action="no-action"
          >
            <v-list-tile slot="activator" ripple="ripple">
              <v-list-tile-content>
                <v-list-tile-title>{{
                  item.route.meta.title
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <template v-for="(subItem, i) in item.items">
              <!--child item-->
              <v-list-tile
                v-if="validPermission(subItem)"
                :key="i"
                :to="genChildTarget(item, subItem)"
                :href="subItem.href"
                :disabled="subItem.disabled"
                :target="subItem.target"
                ripple="ripple"
              >
                <v-list-tile-content>
                  <v-list-tile-title
                    ><span>{{
                      subItem.route.meta.title
                    }}</span></v-list-tile-title
                  >
                </v-list-tile-content>
                <!-- <v-circle class="white--text pa-0 circle-pill" v-if="subItem.badge" color="red" disabled="disabled">{{ subItem.badge }}</v-circle> -->
                <v-list-tile-action v-if="subItem.action">
                  <v-icon :class="[subItem.actionClass || 'success--text']">{{
                    subItem.action
                  }}</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list-group>
          <v-subheader v-else-if="item.header" :key="i">{{
            item.header
          }}</v-subheader>
          <v-divider v-else-if="item.divider" :key="i"></v-divider>
          <!--top-level link-->
          <v-list-tile
            v-else-if="validPermission(item)"
            :to="!item.href ? { name: item.name } : null"
            :href="item.href"
            ripple="ripple"
            :disabled="item.disabled"
            :target="item.target"
            rel="noopener"
            :key="item.name"
          >
            <v-list-tile-action v-if="item.route.meta.icon">
              <v-icon>{{ item.route.meta.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.route.meta.title }}</v-list-tile-title>
            </v-list-tile-content>
            <!-- <v-circle class="white--text pa-0 chip--x-small" v-if="item.badge" :color="item.color || 'primary'" disabled="disabled">{{ item.badge }}</v-circle> -->
            <v-list-tile-action v-if="item.subAction">
              <v-icon class="success--text">{{ item.subAction }}</v-icon>
            </v-list-tile-action>
            <!-- <v-circle class="caption blue lighten-2 white--text mx-0" v-else-if="item.chip" label="label" small="small">{{ item.chip }}</v-circle> -->
          </v-list-tile>
        </template>
      </v-list>
    </vue-perfect-scrollbar>
  </v-navigation-drawer>
</template>
<script>
import { mapGetters } from "vuex";
import menu from "@/api/menu";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import paths from "@/router/paths";

export default {
  name: "app-drawer",
  components: {
    VuePerfectScrollbar
  },
  props: {
    expanded: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    mini: false,
    drawer: true,
    scrollSettings: {
      maxScrollbarLength: 160
    }
  }),
  computed: {
    ...mapGetters(["hasPermission"]),
    menuItems() {
      return menu.map(menuItem => {
        if (menuItem.name) {
          menuItem.route = paths.find(path => {
            return path.name === menuItem.name;
          });
        }
        if (menuItem.items) {
          menuItem.items.map(menuItemChild => {
            if (menuItemChild.name) {
              menuItemChild.route = paths.find(path => {
                return path.name === menuItemChild.name;
              });
            }
            return menuItemChild;
          });
        }
        return menuItem;
      });
    },
    computeLogo() {
      return "/static/img/logo_white.png";
    }
  },
  created() {
    window.getApp.$on("APP_DRAWER_TOGGLED", () => {
      this.drawer = !this.drawer;
    });
  },

  methods: {
    genChildTarget(item, subItem) {
      if (subItem.href) return;
      if (subItem.component) {
        return {
          name: subItem.component
        };
      }
      return { name: `${item.group}/${subItem.name}` };
    },
    validPermission(item) {
      return (
        typeof item.route.meta.permission === "undefined" ||
        this.hasPermission(item.route.meta.permission)
      );
    }
  }
};
</script>

<style lang="stylus">
  @import '../../node_modules/vuetify/src/stylus/settings/_elevations.styl';

#appDrawer
  overflow: hidden
  .drawer-menu--scroll
    height: calc(100vh - 48px)
    overflow: auto
</style>
